<template>
  <div class="autosize-image">
    <img
      :src="src"
      ref="autosizeImage"
      alt=""
      @load="bindLoad"
      :class="[className]"
    />
  </div>
</template>
<script>
export default {
  props: {
    fit: {
      type: String,
      default: 'fill'
    },
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      className: 'fix-width'
    }
  },
  mounted() {},
  methods: {
    bindLoad(e) {
      let img = this.$refs.autosizeImage
      let parent = img.parentElement
      let actualWidth = img.naturalWidth
      let actualHeigh = img.naturalHeight
      let parentWidth = parent.clientWidth
      let parentHeight = parent.clientHeight
      let parentRate = parentWidth / parentHeight
      let actualRate = actualWidth / actualHeigh
      if (actualRate > parentRate) {
        //实际图比较宽
        this.className = 'fix-height'
      } else {
        this.className = 'fix-width'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.autosize-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  .fix-height {
    width: auto;
    height: 100%;
  }
  .fix-width {
    width: 100%;
    height: auto;
  }
}
</style>
